<div class="info">
    <div class="info-content">
        <div class="content-icon">
            <h3 class="content-icon-left">«</h3>
        </div>
        <div class="content-text">
            <h3 class="content-title"><span>Wineincognito</span> - незнакомец с силой сотни сомелье</h3>
            <p class="content-subtitle">
                Наш сервис выручит большое количество специалистов — менеджеров по закупке алкоголя, кавистов в
                винотеках
                и алкоотделах в сетевых магазинах, кавистов в барах
                и ресторанах, самих рестораторов, ответственных за все,
                что связанное с вином – в отелях, гостиницах, объектах туристической сферы.
            </p>
        </div>
        <div class="content-icon">
            <h3 class="content-icon-right">»</h3>
        </div>
    </div>
    <div class="info-banner">
        <div class="img-block">
            <img src="../../../assets/img/info-banner.png" alt="#">
        </div>
        <h4 class="info-name">Алексей Соловьев </h4>
        <p class="info-subtitle">президент ассоциации кавистов России </p>
    </div>
</div>
